import type { ReactNode } from 'react';

/** Same tag shape as functions/src/utils/parseHashtags.ts */
const HASHTAG_RE = /#([a-zA-Z0-9_]{1,40})/g;

export function discoverHashtagHref(locale: string, tag: string): string {
  const loc = locale || 'en';
  return `/${loc}/discover/?q=${encodeURIComponent(`#${tag}`)}`;
}

/** Extract unique lowercase hashtags from freeform text (max 40). */
export function extractHashtags(text: string): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  HASHTAG_RE.lastIndex = 0;
  let m: RegExpExecArray | null;
  while ((m = HASHTAG_RE.exec(text)) !== null) {
    const tag = m[1]!.toLowerCase();
    if (seen.has(tag)) continue;
    seen.add(tag);
    out.push(tag);
    if (out.length >= 40) break;
  }
  return out;
}

/** Render text with #hashtags as discover search links. */
export function linkifyHashtags(
  text: string,
  locale: string,
  linkClassName?: string,
): ReactNode {
  const parts: ReactNode[] = [];
  HASHTAG_RE.lastIndex = 0;
  let last = 0;
  let m: RegExpExecArray | null;
  let key = 0;
  while ((m = HASHTAG_RE.exec(text)) !== null) {
    if (m.index > last) {
      parts.push(text.slice(last, m.index));
    }
    const tag = m[1]!;
    parts.push(
      <a
        key={`tag-${key++}-${tag}`}
        className={linkClassName}
        href={discoverHashtagHref(locale, tag)}
      >
        #{tag}
      </a>,
    );
    last = m.index + m[0].length;
  }
  if (key === 0) {
    return text;
  }
  if (last < text.length) {
    parts.push(text.slice(last));
  }
  return parts;
}
